import { Form, Input } from "antd";
import React from "react";
import { Controller } from "react-hook-form";
const { TextArea } = Input;

function InputField({
  control,
  errors,
  label,
  name,
  className,
  required,
  placeholder,
  type,
  disabled,rows ,defaultValue,suffix,
}) {
  return (
    <Form.Item
      name={name}
      validateStatus={errors?.role ? "error" : ""}
      help={errors?.role?.message}
      className={`mb-4 d-block ${className}`}
    >
      <div className="mb-2 ">{label}</div>
      <Controller
        name={name}
        control={control}
        rules={required}
        render={({ field }) =>
          type === "password" ? (
            <Input.Password readOnly={disabled} {...field} suffix={suffix}/>
          ) : type === "textarea" ? (
            <TextArea defaultValue={defaultValue} rows={rows} readOnly={disabled} {...field} />
          ) : (
            <Input
              readOnly={disabled} suffix={suffix}
              placeholder={placeholder}
              type={type}
              {...field}
            />
          )
        }
      />
    </Form.Item>
  );
}

export default InputField;
